export class Address {
    id?: string = '';
    street?: string = '';
    suite?: string = '';
    poBox?: string = '';
    city?: string = '';
    stateCode?: string = '';
    zipCode?: string = '';
    organizationId?: string = '';
    contactId?: string = '';
    guarantorId?: string = '';
    inspectionId?: number;
} 